import React from 'react';
import { motion } from 'framer-motion';
export function Team() {
  const team = [{
    name: 'Dra. Valentina Reyes',
    role: 'Directora Médica',
    bio: 'Especialista en medicina interna con más de 15 años de experiencia liderando equipos veterinarios de alto rendimiento.',
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&q=80'
  }, {
    name: 'Dr. Martín Lagos',
    role: 'Cirujano Veterinario',
    bio: 'Experto en cirugías de tejidos blandos y traumatología. Pionero en técnicas mínimamente invasivas.',
    image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&q=80'
  }, {
    name: 'Lic. Camila Herrera',
    role: 'Especialista en Bienestar Animal',
    bio: 'Dedicada a la rehabilitación física y el comportamiento animal, asegurando una recuperación integral.',
    image: 'https://images.unsplash.com/photo-1594824476967-48c8b964ac31?w=400&q=80'
  }];
  return <section id="equipo" className="py-24 md:py-32 bg-cream" data-id="element-105">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center mb-20" data-id="element-107">
          <h2 className="text-4xl md:text-5xl text-matte" data-id="element-108">Nuestro Equipo</h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-109">
          {team.map((member, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.15,
          ease: [0.22, 1, 0.36, 1]
        }} className="flex flex-col items-center text-center" data-id="element-110">
              <div className="w-48 h-48 md:w-56 md:h-56 mb-8 overflow-hidden rounded-2xl bg-sand/20" data-id="element-111">
                <img src={member.image} alt={member.name} className="w-full h-full object-cover grayscale-[20%] hover:grayscale-0 transition-all duration-500" data-id="element-112" />
              </div>
              <h3 className="text-2xl text-matte mb-2" data-id="element-113">{member.name}</h3>
              <p className="text-terracotta text-sm tracking-widest uppercase mb-4" data-id="element-114">
                {member.role}
              </p>
              <p className="text-matte/70 leading-relaxed max-w-xs" data-id="element-115">
                {member.bio}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}